import { useAuth } from "react-oidc-context";

export function SignOutButton() {
  const auth = useAuth();
  const username = auth.user?.profile.preferred_username ?? auth.user?.profile.sub;
  return (
    <button
      onClick={() => auth.signoutRedirect()}
      title={`Signed in as ${username ?? "unknown"}. Click to sign out.`}
      style={{
        background: "transparent",
        color: "var(--text-dim)",
        border: "1px solid var(--border)",
        padding: "4px 12px",
        borderRadius: 999,
        fontSize: "0.8rem",
        cursor: "pointer",
      }}
    >
      {username ?? "Signed in"} · Sign out
    </button>
  );
}
